import axiosInstance from './AxiosInstance';

const BASE = '/flowdo-roles';

export const flowdoRoleService = {
  getCatalog: () => axiosInstance.get(`${BASE}/catalog`),
  list: () => axiosInstance.get(BASE),
  get: (id) => axiosInstance.get(`${BASE}/${id}`),
  create: (payload) => axiosInstance.post(BASE, payload),
  update: (id, payload) => axiosInstance.put(`${BASE}/${id}`, payload),
  updateAccess: (id, sections) => axiosInstance.put(`${BASE}/${id}/access`, { sections }),
  remove: (id) => axiosInstance.delete(`${BASE}/${id}`),
};
